
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.028 10.224c0-.822-.068-1.422-.216-2.044h-9.609v3.711h5.64c-.113.922-.727 2.311-2.092 3.245l-.02.124 3.039 2.3.21.02c1.933-1.744 3.048-4.311 3.048-7.356z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.205 20.001c2.763 0 5.083-.889 6.777-2.422l-3.23-2.445c-.863.59-2.023 1-3.547 1a6.148 6.148 0 01-5.822-4.155l-.12.01-3.16 2.389-.04.112C3.744 17.757 7.202 20 11.204 20z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.38 11.979A6.03 6.03 0 015.04 10c0-.69.125-1.356.33-1.978l-.006-.133-3.199-2.427-.105.049A9.825 9.825 0 00.97 10c0 1.611.398 3.133 1.091 4.489l3.32-2.511z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M11.205 3.867c1.922 0 3.218.811 3.957 1.489L18.05 2.6C16.277.99 13.968 0 11.206 0c-4.003 0-7.46 2.245-9.143 5.512l3.31 2.51a6.174 6.174 0 015.833-4.155z","fill":"currentColor"}})])
          )
        }
      }
    